<template >
  <template v-if="inputModel && inputModel.length > 0">
    <ul class="list-group border border-light2 mb-2">
      <draggable
          :list="inputModel"
          itemKey="key_id"
          handle=".move"
          :ghost-class="getConfig('general.style.class_drag_n_drop')"
      >
        <template #item="{ index, element }">
          <li
              class="list-group-item py-3 d-flex align-items-center"
          >

            <div>
              <div>
                {{element.title}}
                <i
                    v-if="element.ico_class"
                    :class="element.ico_class + ' ms-1'"
                >
                </i>
              </div>

              <div
                  v-if="element.description"
                  class="text-muted ms-md-4"
              >
                {{element.description}}
              </div>
           </div>

            <div
              class="ms-auto"
            >
              <template
                v-for="(action) in element.actions"
              >
                <router-link
                    v-if="action.type == 'btn_link'"
                    :to="action.uri"
                    target="_blank"
                    class="btn btn-outline-secondary me-1"
                    :title="action.title"
                >
                  <i
                      :class="action.ico_class"
                  ></i>
                </router-link>
              </template>

              <span class="btn btn-outline-secondary move">
                <i class="bi bi-arrows-move"></i>
              </span>
            </div>
          </li>
        </template>
      </draggable>
    </ul>

  </template>

  <template v-else>
    {{inputObj.params.texts.empty_data}}
  </template>


</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "OrderInput",
  components: {
    draggable,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, Array],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: {},


      selectModel: null,
      options:[],
      optionsArr:[],
    }
  },
  mounted() {
    this.inputModel = this.inputObj.val;
  },
  methods: {

  },
  watch: {
    inputModel: {
      handler(newVal) {

        if(newVal && newVal.length > 0) {
          //console.log('dev order watch X', newVal)
          for (const i in newVal) {
            newVal[i].poradi = (parseInt(i) + 1) * 10;
          }
        }
        this.$emit('update:modelValue', newVal)
      },
      deep: true,
      immediate: true
    },
  },
};
</script>